var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "ag-grid-detail-renderer" },
    [
      _vm.showDetail === _vm.detailMapping["detail"] && !_vm.callDetails
        ? _c(
            "div",
            {
              staticClass: "ag-custom-loading-cell p-l-15 p-t-5",
              staticStyle: { "line-height": "25px" }
            },
            [
              _c("i", { staticClass: "fa fa-spinner fa-pulse fa-fw" }),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "LOADING_CALL_DETAILS",
                    expression: "'LOADING_CALL_DETAILS'"
                  }
                ]
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showDetail === _vm.detailMapping["blockNumber"]
        ? _c("BlockNumberForm", {
            attrs: {
              "show-loader": _vm.showCallLogActionLoaderStatus,
              campaigns: _vm.campaigns,
              "phone-number": _vm.inboundNumber,
              "cached-number": _vm.cachedData,
              "campaign-id": _vm.params.node.data.campaignId
            },
            on: {
              closeForm: _vm.closeForm,
              setDetailRowHeight: _vm.setDetailRowHeight,
              blockNumberSubmit: _vm.blockNumberSubmit,
              cacheFormData: _vm.cacheFormData
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showDetail === _vm.detailMapping["annotate"]
        ? _c("CallAnnotateForm", {
            attrs: {
              "show-loader": _vm.showCallLogActionLoaderStatus,
              "recent-tags": _vm.recentTags,
              "cached-data": _vm.cachedData
            },
            on: {
              closeForm: _vm.closeForm,
              setDetailRowHeight: _vm.setDetailRowHeight,
              annotateCallSubmit: _vm.annotateCallSubmit,
              cacheFormData: _vm.cacheFormData
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showDetail === _vm.detailMapping["adjustPayment"]
        ? _c("CallPaymentOverrideForm", {
            attrs: {
              "cached-data": _vm.cachedData,
              "is-admin": _vm.isAdmin,
              "show-loader": _vm.showCallLogActionLoaderStatus,
              call: _vm.params.node.data
            },
            on: {
              setDetailRowHeight: _vm.setDetailRowHeight,
              closeForm: _vm.closeForm,
              callPaymentAdjustmentSubmit: _vm.callPaymentAdjustmentSubmit,
              cacheFormData: _vm.cacheFormData
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showDetail === _vm.detailMapping["detail"] && _vm.callDetails
        ? _c(
            "tabs",
            {
              staticClass: "p-t-3",
              attrs: {
                "transition-duration": 0,
                "custom-nav-class": "nav-compact"
              },
              on: { change: _vm.handleTabChange },
              model: {
                value: _vm.currentTabIndex,
                callback: function($$v) {
                  _vm.currentTabIndex = $$v
                },
                expression: "currentTabIndex"
              }
            },
            [
              _c(
                "tab",
                { staticClass: "p-b-5", attrs: { title: _vm.$t("EVENTS") } },
                [
                  _c("EventsCallLogDetail", {
                    attrs: {
                      "panel-tab-index": 0,
                      "current-tab-index": _vm.currentTabIndex,
                      events: _vm.mainEvents,
                      "time-zone-id": _vm.timeZoneId,
                      role: _vm.role
                    },
                    on: {
                      setDetailRowHeight: _vm.setDetailRowHeight,
                      addFilter: _vm.addFilter
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "tab",
                { staticClass: "p-b-5", attrs: { title: _vm.$t("RECORD") } },
                [
                  _c("CallRecordsCallLogDetail", {
                    attrs: {
                      "panel-tab-index": 1,
                      "current-tab-index": _vm.currentTabIndex,
                      "call-record": _vm.callRecord,
                      "col-defs": _vm.params.context.componentParent.columnDefs,
                      "column-types":
                        _vm.params.context.componentParent.columnTypes
                    },
                    on: {
                      setDetailRowHeight: _vm.setDetailRowHeight,
                      addFilter: _vm.addFilter
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.displayTags
                ? _c(
                    "tab",
                    { staticClass: "p-b-5", attrs: { title: "Tags" } },
                    [
                      _c("TagsCallLogDetail", {
                        attrs: {
                          "panel-tab-index": 2,
                          "current-tab-index": _vm.currentTabIndex,
                          "grouped-tags": _vm.groupedTags,
                          "tag-actions-available": _vm.tagActionsAvailable
                        },
                        on: {
                          setDetailRowHeight: _vm.setDetailRowHeight,
                          addFilter: _vm.addFilter,
                          addTagAsColumn: _vm.addTagAsColumn
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasRingTreeEvents
                ? _c(
                    "tab",
                    {
                      staticClass: "p-b-5",
                      attrs: { title: _vm.$t("RING_TREE_EVENTS") }
                    },
                    [
                      _c("EventsCallLogDetail", {
                        attrs: {
                          "panel-tab-index": 3,
                          "current-tab-index": _vm.currentTabIndex,
                          events: _vm.ringTreeEvents,
                          "time-zone-id": _vm.timeZoneId,
                          role: _vm.role
                        },
                        on: {
                          setDetailRowHeight: _vm.setDetailRowHeight,
                          addFilter: _vm.addFilter
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasTranscription || _vm.hasRecording
                ? _c(
                    "tab",
                    {
                      staticClass: "p-b-5",
                      attrs: { title: _vm.$t("TRANSCRIPTION") }
                    },
                    [
                      _c("TranscriptionCallLogDetail", {
                        attrs: {
                          "panel-tab-index": _vm.transcriptionTabIndex,
                          "current-tab-index": _vm.currentTabIndex,
                          "time-zone-id": _vm.timeZoneId,
                          role: _vm.role,
                          "call-details": _vm.callDetails,
                          "has-transcription": _vm.hasTranscription,
                          "is-transcription-pending": _vm.isTranscriptionPending
                        },
                        on: { setDetailRowHeight: _vm.setDetailRowHeight }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }